import { render, staticRenderFns } from "./MiniGameLevels.vue?vue&type=template&id=72f98e3b&scoped=true"
import script from "./MiniGameLevels.vue?vue&type=script&lang=js"
export * from "./MiniGameLevels.vue?vue&type=script&lang=js"
import style0 from "./MiniGameLevels.vue?vue&type=style&index=0&id=72f98e3b&prod&scoped=true&lang=css"
import style1 from "./MiniGameLevels.vue?vue&type=style&index=1&id=72f98e3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f98e3b",
  null
  
)

export default component.exports